import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=dd407f26&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=dd407f26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd407f26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd407f26')) {
      api.createRecord('dd407f26', component.options)
    } else {
      api.reload('dd407f26', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=dd407f26&scoped=true&", function () {
      api.rerender('dd407f26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2iFucYBrI3F5P/JS/comp/GuestBox.vue"
export default component.exports